var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_597",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FEDA75"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_597)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_radial_22_597)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint1_radial_22_597)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6503 35.6482C36.3524 34.9439 36.9038 34.0975 37.2634 33.1693C37.608 32.2777 37.8449 31.2611 37.9139 29.7708C37.9828 28.2783 38 27.8002 38 23.9989C38 20.1977 37.9828 19.7196 37.9139 18.2271C37.8449 16.7367 37.608 15.7202 37.2634 14.8286C36.9118 13.8946 36.3605 13.0486 35.6482 12.3497C34.9491 11.6374 34.1032 11.0862 33.1693 10.7344C32.2777 10.3898 31.2611 10.1529 29.7708 10.084C28.2783 10.0151 27.8002 10 23.9989 10C20.1977 10 19.7196 10.0151 18.2271 10.0861C16.7367 10.1508 15.7202 10.3877 14.8286 10.7344C13.8951 11.087 13.0493 11.6381 12.3497 12.3497C11.6381 13.0493 11.087 13.8951 10.7344 14.8286C10.3898 15.7202 10.1529 16.7367 10.084 18.2271C10.0151 19.7196 10 20.1977 10 23.9989C10 27.8002 10.0151 28.2783 10.0861 29.7708C10.1508 31.2611 10.3877 32.2777 10.7344 33.1693C11.0876 34.104 11.639 34.9482 12.3497 35.6482C13.0496 36.3589 13.896 36.9102 14.8286 37.2634C15.7202 37.608 16.7367 37.8449 18.2271 37.9139C19.7196 37.9806 20.1977 37.9978 23.9989 37.9978C27.8002 37.9978 28.2783 37.9806 29.7708 37.9117C31.2611 37.8471 32.2777 37.6102 33.1693 37.2634C34.0991 36.9036 34.9456 36.3534 35.6503 35.6482ZM12.1537 22.3514V25.6465C12.1494 27.4147 12.1494 27.8734 12.1968 28.877C12.2527 30.1391 12.3217 31.0651 12.5327 31.7629C12.7352 32.4349 12.9613 33.1198 13.7022 33.9425C14.443 34.7673 15.1559 35.1399 16.0648 35.4156C16.9758 35.6891 18.1194 35.7473 19.1122 35.7925C20.2364 35.8442 20.6844 35.8442 23.0448 35.8442H25.5926C27.406 35.8463 27.8626 35.8485 28.8792 35.8011C30.1391 35.7429 31.0651 35.674 31.7651 35.4651C32.4349 35.2627 33.1198 35.0344 33.9425 34.2957C34.7673 33.5548 35.1399 32.8398 35.4156 31.9309C35.6891 31.0221 35.7494 29.8785 35.7946 28.8856C35.8442 27.7614 35.8442 27.3156 35.8442 24.9616V23.0448C35.8442 20.6844 35.8442 20.2386 35.7946 19.1122C35.7494 18.1194 35.6891 16.9758 35.4156 16.0669C35.1421 15.1559 34.7695 14.443 33.9425 13.7022C33.1176 12.9613 32.4349 12.7352 31.7651 12.5327C31.0651 12.3238 30.1391 12.2527 28.8792 12.1968C27.7843 12.1518 26.6883 12.1374 25.5926 12.1537H23.0448C20.6844 12.1537 20.2364 12.1537 19.1122 12.2032C18.1194 12.2484 16.9758 12.3087 16.0648 12.5823C15.1559 12.8579 14.443 13.2305 13.7022 14.0554C12.9613 14.8802 12.733 15.563 12.5327 16.2349C12.3217 16.9327 12.2527 17.8588 12.1968 19.1208C12.1494 20.1245 12.1494 20.5832 12.1537 22.3514ZM23.9989 19.1531C22.7137 19.1531 21.4812 19.6637 20.5724 20.5724C19.6637 21.4812 19.1531 22.7137 19.1531 23.9989C19.1531 25.2841 19.6637 26.5166 20.5724 27.4254C21.4812 28.3342 22.7137 28.8447 23.9989 28.8447C25.2841 28.8447 26.5166 28.3342 27.4254 27.4254C28.3342 26.5166 28.8447 25.2841 28.8447 23.9989C28.8447 22.7137 28.3342 21.4812 27.4254 20.5724C26.5166 19.6637 25.2841 19.1531 23.9989 19.1531ZM16.9995 23.9989C16.9995 22.1426 17.7369 20.3622 19.0496 19.0496C20.3622 17.7369 22.1425 16.9995 23.9989 16.9995C25.8553 16.9995 27.6356 17.7369 28.9483 19.0496C30.2609 20.3622 30.9984 22.1426 30.9984 23.9989C30.9984 25.8553 30.2609 27.6356 28.9483 28.9483C27.6356 30.2609 25.8553 30.9984 23.9989 30.9984C22.1425 30.9984 20.3622 30.2609 19.0496 28.9483C17.7369 27.6356 16.9995 25.8553 16.9995 23.9989ZM31.4722 18.1409C31.9006 18.1409 32.3114 17.9707 32.6144 17.6678C32.9173 17.3649 33.0875 16.954 33.0875 16.5257C33.0875 16.0973 32.9173 15.6864 32.6144 15.3835C32.3114 15.0806 31.9006 14.9104 31.4722 14.9104C31.0438 14.9104 30.633 15.0806 30.33 15.3835C30.0271 15.6864 29.8569 16.0973 29.8569 16.5257C29.8569 16.954 30.0271 17.3649 30.33 17.6678C30.633 17.9707 31.0438 18.1409 31.4722 18.1409Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_22_597",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.56 54.48) rotate(-115.776) scale(65.4568 97.3596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24392,
    stopColor: "#FF1B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436673,
    stopColor: "#F80261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688476,
    stopColor: "#ED00C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776787,
    stopColor: "#C500E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893155,
    stopColor: "#7017FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_22_597",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4 46.344) rotate(-57.4396) scale(28.3618 29.5003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF6930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FE3B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3B36",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosInstagramIcon);
export default __webpack_public_path__ + "static/media/logos_instagram-icon.028a768bda5fef82e8bd02482714ebc7.svg";
export { ForwardRef as ReactComponent };